import { useState } from 'react';

const faqItems = [
  {
    question: 'Czy Kakobuy Spreadsheet jest darmowy?',
    answer: 'Tak, Kakobuy Spreadsheet jest całkowicie darmowy. Społeczność udostępnia bazę produktów bezpłatnie. Nie ma żadnych ukrytych opłat ani wymaganych subskrypcji.',
  },
  {
    question: 'Jak często aktualizowany jest Kakobuy Spreadsheet?',
    answer: 'Kakobuy Spreadsheet jest aktualizowany regularnie przez społeczność użytkowników. Nowe produkty pojawiają się praktycznie codziennie, a nieaktualne linki są szybko usuwane.',
  },
  {
    question: 'Czy mogę ufać produktom z Kakobuy Spreadsheet?',
    answer: 'Zdecydowana większość produktów przeszła weryfikację przez społeczność. Każdy link był już sprawdzony, a wiele z nich ma zdjęcia QC i szczegółowe recenzje. Mimo to zawsze zachowuj podstawową ostrożność.',
  },
  {
    question: 'Jakie kategorie produktów znajdę w arkuszu?',
    answer: 'Kakobuy Spreadsheet oferuje szeroki wybór kategorii — od butów, przez odzież, akcesoria, torby, paski, aż po perfumy i elektronikę. Arkusz jest regularnie rozszerzany o nowe kategorie.',
  },
  {
    question: 'Czy Kakobuy jest bezpieczny dla kupujących z Polski?',
    answer: 'Tak, Kakobuy jest bezpieczną platformą dla kupujących z Polski, pod warunkiem przestrzegania podstawowych zasad bezpieczeństwa. Platforma oferuje ochronę kupujących i system ocen sprzedawców.',
  },
  {
    question: 'Jak zacząć korzystać z Kakobuy Spreadsheet?',
    answer: 'Wystarczy otworzyć arkusz i przeglądać dostępne kategorie. Każdy link prowadzi bezpośrednio do produktu. Dla początkujących przygotowaliśmy szczegółowy poradnik, który krok po kroku wyjaśnia cały proces.',
  },
];

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            Często zadawane pytania
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            Odpowiedzi na najczęściej zadawane pytania dotyczące Kakobuy Spreadsheet
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="rounded-lg bg-background-100 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {item.question}
                </span>
                <i
                  className={`flex-shrink-0 text-base transition-transform duration-200 ${
                    openIndex === i ? 'rotate-45 ri-add-line text-primary-500' : 'ri-add-line text-foreground-400'
                  }`}
                ></i>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}